const AWS_URL = "https://api.char-gen.com";
const HELP_VIDEO_URL =
    "https://charsheet-gen.s3.eu-west-2.amazonaws.com/HowToGuide.mp4";
const STRIPE_CUSTOMER_PORTAL =
    "https://billing.stripe.com/p/login/dR64gjfhZbhrfwQ9AA";
export { AWS_URL, HELP_VIDEO_URL, STRIPE_CUSTOMER_PORTAL };
